import {
  ACCOUNT_TO_ACCOUNT_INBOUND,
  ACCOUNT_TO_ACCOUNT_NEW,
  ACCOUNT_TO_ACCOUNT_OUTBOUND,
  DELIVERED,
  PAL_ESCROW_DERIVED,
  PAL_PRINCIPAL_DERIVED,
  PROCESSED,
  FUNDED,
  TRANSACTION_TYPE_PAL,
} from 'consts';

export const NOC = 'NOC';
export const NOR = 'NOR';

export const isNOCOrNOA = ({ status, transactionType }) =>
  [
    ACCOUNT_TO_ACCOUNT_INBOUND,
    ACCOUNT_TO_ACCOUNT_NEW,
    ACCOUNT_TO_ACCOUNT_OUTBOUND,
    PAL_ESCROW_DERIVED,
    PAL_ESCROW_DERIVED,
    PAL_PRINCIPAL_DERIVED,
    TRANSACTION_TYPE_PAL,
    TRANSACTION_TYPE_PAL_PRINCIPAL,
    TRANSACTION_TYPE_PAL_INTEREST,
    TRANSACTION_TYPE_PAL_ESCROW,
  ].includes(transactionType) &&
  [DELIVERED, PROCESSED, FUNDED].includes(status);

export const TRANSACTION_TYPE_PAL_PRINCIPAL = 'palPrincipal';
export const TRANSACTION_TYPE_PAL_INTEREST = 'palInterest';
export const TRANSACTION_TYPE_PAL_ESCROW = 'palEscrow';
